import { fansupportPrivate } from "../index";

export const postCampaign = async ( campaignId, joinId, amount ) => {
    //  console.log("payload", campaignId);
    try {
        const data =  fansupportPrivate.post('/campaign/join', {
            campaignId: campaignId,
            joinId: joinId,
            amount: amount
    })
        return data;

    } catch (error) {
        console.log("postCampaignError",error);
    }
}